import { render, staticRenderFns } from "./SupportFormDialog.vue?vue&type=template&id=89903c3c&scoped=true&"
import script from "./SupportFormDialog.vue?vue&type=script&lang=js&"
export * from "./SupportFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./SupportFormDialog.vue?vue&type=style&index=0&id=89903c3c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89903c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDialog,VIcon})
